<template>
  <div class="work-order-center">
      <div class="metrics-grid">
        <div class="metric-card" v-for="(item, index) in basicMetrics" :key="index">
          <div class="metric-icon">
            <img :src="getIconUrl(index)" alt="" />
          </div>
          <div class="metric-content">
            <div class="metric-label">{{ item.text }}</div>
            <div class="metric-value">{{ formatNumber(item.num) }}</div>
          </div>
        </div>
      </div>
      
      <div class="yearly-stats">
        <div class="stat-item" v-for="(item, index) in yearlyMetrics" :key="index">
          <div class="stat-title">{{ item.title }}</div>
          <div class="stat-value">{{ formatNumber(item.num) }}</div>
          <div class="stat-trend" :class="getTrendClass(item.hb)">
            <i :class="getTrendIcon(item.hb)"></i>
            {{ formatTrend(item.hb) }}
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import { postAction } from '@/api/manage'
export default {
  name: 'WorkOrderCenter',
  components: {

  },
  data() {
    return {
      basicMetrics: [
        { text: this.$t('本月工单'), num: 0, unit: this.$t('件') },
        { text: this.$t('本周工单'), num: 0, unit: this.$t('件') },
        { text: this.$t('昨日工单'), num: 0, unit: this.$t('件') },
        { text: this.$t('待处理工单'), num: 0, unit: this.$t('件') }
      ],
      yearlyMetrics: [
        { title: this.$t('本年工单总数'), num: 0, hb: 0, unit: this.$t('件') },
        { title: this.$t('本年已完成'), num: 0, hb: 0, unit: this.$t('件') },
        { title: this.$t('本年未完成'), num: 0, hb: 0, unit: this.$t('件') },
        { title: this.$t('本年超时未完成'), num: 0, hb: 0, unit: this.$t('件') },
        { title: this.$t('本年工单完成率'), num: 0, hb: 0, unit: '%' }
      ],
      url: {
        queryBasicInformation: "/jeecg-engineering/ticket/index/largeScreen/queryBasicInformation",
        queryHomeIndexDisposeNum: "/jeecg-engineering/ticket/tickets/queryHomeIndexDisposeNum"
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getBasicData()
      this.getYearlyData()
    },
    async getBasicData() {
      try {
        const res = await postAction(this.url.queryBasicInformation, {})
        if (res.success) {
          const data = res.result
          this.basicMetrics[0].num = data.monthTicketsNum || 0
          this.basicMetrics[1].num = data.weekTicketsNum || 0
          this.basicMetrics[2].num = data.lastDayTicketsNum || 0
          this.basicMetrics[3].num = data.toTicketsNum || 0
        }
      } catch (error) {
        console.error('获取基本指标数据失败:', error)
        this.loadMockBasicData()
      }
    },
    async getYearlyData() {
      try {
        const res = await postAction(this.url.queryHomeIndexDisposeNum, { queryType: 3 })
        if (res.success) {
          const data = res.result
          this.yearlyMetrics[0].num = data.ticketsNum || 0
          this.yearlyMetrics[1].num = data.finishTicketsNum || 0
          this.yearlyMetrics[2].num = data.unFinishTicketsNum || 0
          this.yearlyMetrics[3].num = data.timeOutTicketsNum || 0
          this.yearlyMetrics[4].num = (data.ticketsFinishRatio * 100).toFixed(2)
          
          this.yearlyMetrics[0].hb = data.comparableMessage?.ticketsRate || 0
          this.yearlyMetrics[1].hb = data.comparableMessage?.finishRate || 0
          this.yearlyMetrics[2].hb = data.comparableMessage?.unFinishRate || 0
          this.yearlyMetrics[3].hb = data.comparableMessage?.timeoutUnFinishRate || 0
          this.yearlyMetrics[4].hb = data.comparableMessage?.ticketsFinishRate || 0
        }
      } catch (error) {
        console.error('获取年度数据失败:', error)
        this.loadMockYearlyData()
      }
    },
    loadMockBasicData() {
      this.basicMetrics = [
        { text: this.$t('本月工单'), num: 1234, unit: this.$t('件') },
        { text: this.$t('本周工单'), num: 456, unit: this.$t('件') },
        { text: this.$t('昨日工单'), num: 78, unit: this.$t('件') },
        { text: this.$t('待处理工单'), num: 23, unit: this.$t('件') }
      ]
    },
    loadMockYearlyData() {
      this.yearlyMetrics = [
        { title: this.$t('本年工单总数'), num: 15678, hb: 0.15, unit: this.$t('件') },
        { title: this.$t('本年已完成'), num: 14230, hb: 0.23, unit: this.$t('件') },
        { title: this.$t('本年未完成'), num: 1448, hb: -0.12, unit: this.$t('件') },
        { title: this.$t('本年超时未完成'), num: 89, hb: -0.08, unit: this.$t('件') },
        { title: this.$t('本年工单完成率'), num: 90.8, hb: 0.05, unit: '%' }
      ]
    },
    getIconUrl(index) {
      const icons = [
        require('@/assets/images/menu-yw.png'),
        require('@/assets/images/menu-yw.png'),
        require('@/assets/images/menu-yw.png'),
        require('@/assets/images/menu-yw.png')
      ]
      return icons[index]
    },
    formatNumber(num) {
      return num.toLocaleString()
    },
    getTrendClass(hb) {
      return hb >= 0 ? 'trend-up' : 'trend-down'
    },
    getTrendIcon(hb) {
      return hb >= 0 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
    },
    formatTrend(hb) {
      const value = Math.abs(hb * 100).toFixed(1)
      return hb >= 0 ? `+${value}%` : `-${value}%`
    }
  }
}
</script>

<style lang="less" scoped>
.work-order-center {
  height: 100%;
  padding: 10px;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 10px;
}

.metric-card {
  background: linear-gradient(135deg, rgba(1, 32, 67, 0.8) 0%, rgba(0, 48, 111, 0.6) 100%);
  border: 1px solid rgba(0, 170, 255, 0.3);
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 15px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    border-color: rgba(0, 170, 255, 0.6);
    box-shadow: 0 4px 12px rgba(0, 170, 255, 0.2);
  }
}

.metric-icon {
  width: 50px;
  height: 50px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.metric-content {
  flex: 1;
}

.metric-label {
  color: #b6deff;
  font-size: 14px;
  margin-bottom: 5px;
}

.metric-value {
  color: #fff;
  font-size: 28px;
  font-weight: bold;
  font-family: 'ds-digital-bold';
}

.yearly-stats {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
}

.stat-item {
  background: rgba(0, 48, 111, 0.4);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 6px;
  padding: 15px;
  text-align: center;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(0, 48, 111, 0.6);
    border-color: rgba(0, 170, 255, 0.4);
  }
}

.stat-title {
  color: #a8c6f3;
  font-size: 12px;
  margin-bottom: 8px;
}

.stat-value {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  font-family: 'ds-digital-bold';
  margin-bottom: 5px;
}

.stat-trend {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  
  &.trend-up {
    color: #52c41a;
  }
  
  &.trend-down {
    color: #ff4d4f;
  }
}

@media (max-width: 1600px) {
  .metrics-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .yearly-stats {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
}

@media (max-width: 1200px) {
  .yearly-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>